import React from 'react';
import {FluidContainer} from '../';
import {FiltersContainer} from './styles';

export default ({children, bColor = 'var(--BackgroundLighter)'}: {children: React.ReactNode; bColor?: string}) => (
  <FiltersContainer bColor={bColor}>
    <FluidContainer>{children}</FluidContainer>
  </FiltersContainer>
);
